<script lang="ts">
  import { toast, xhr, wait } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import { Lock } from "lucide-svelte"
  import { appStore } from "$app/store.svelte"

  let form = {
    send_daily_updates: null,
    send_weekly_report: null,
    weekly_meeting_day: null,
    ...appStore.plan
  }
  let saving = false

  const WEEK_DAYS = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
  ]

  let saveEmailSettings = async () => {
    saving = true
    try {
      await wait(100)
      await xhr.patch(`/plans/${appStore.plan.id}.json`, {
        plan: form
      })

      toast("Plan Email settings have been saved!", "success")
    } catch (e) {
      Honeybadger.notify(e)
      toast("There was an error saving Email settings", "error")
    } finally {
      saving = false
    }
  }
</script>

<div
  class="max-w-4xl mx-auto space-y-8 divide-y divide-gray-200 sm:space-y-1 px-1 md:px-8"
>
  <div>
    {#if appStore.subscription.subscription_type === "free"}
      <h2 class="text-lg font-semibold leading-7 text-gray-900">
        Global Plan Email Settings
      </h2>
      <div
        class="md:mx-4 mt-4 py-3 px-4 rounded-md bg-yellow-50 border border-yellow-200 text-yellow-800 flex items-center"
      >
        <Lock class="size-6 mr-3 flex-shrink-0" />
        <div class="text-sm">
          Email reports are not available at your current Free Subscription.
          <a
            href={`/plans/${appStore.plan.id}/admin`}
            class="font-medium underline text-yellow-900 hover:text-yellow-800"
            >Upgrade your plan</a
          >
          to access these features.
        </div>
      </div>
    {:else}
      <div class="mt-3">
        <h2 class="text-lg font-semibold leading-7 text-gray-900">
          Global Plan Email Settings
        </h2>
        <p class="mt-1 text-sm leading-6 text-gray-600">
          <b>Please note:</b> these settings will affect the email delivery for all
          your plan members.
        </p>

        <div
          class="grid grid-cols-4 gap-x-4 gap-y-2 items-start pt-5 justify-center"
        >
          <div class="col-span-2 md:col-span-1">
            <label
              for="username"
              class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2 text-right"
            >
              Send Daily Update Email?
            </label>
          </div>
          <div class="col-span-2 md:col-span-3">
            <div class="max-w-lg flex">
              <label class="cursor-pointer">
                <input
                  type="radio"
                  name="send_daily_updates"
                  bind:group={form.send_daily_updates}
                  value={true}
                />
                <span>Yes</span>
              </label>
              <label class="ml-4 cursor-pointer">
                <input
                  type="radio"
                  name="send_daily_emails"
                  bind:group={form.send_daily_updates}
                  value={false}
                />
                <span>No</span>
              </label>
            </div>
          </div>
          <div class="col-start-2 col-span-3">
            <p class="text-gray-500 italic text-sm mt-2">
              Daily summary of activity including recognitions and goal/task
              updates.
            </p>
          </div>
        </div>
      </div>

      <div class="mt-3">
        <div
          class="grid grid-cols-4 gap-x-4 gap-y-2 items-start pt-5 justify-center"
        >
          <div class="col-span-2 md:col-span-1">
            <label
              for="username"
              class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2 text-right"
            >
              Send Weekly Report?
            </label>
          </div>
          <div class="col-span-2 md:col-span-3">
            <div class="max-w-lg flex">
              <label class="cursor-pointer">
                <input
                  type="radio"
                  name="send_weekly_emails"
                  bind:group={form.send_weekly_report}
                  value={true}
                />
                <span>Yes</span>
              </label>
              <label class="ml-4 cursor-pointer">
                <input
                  type="radio"
                  name="send_weekly_emails"
                  bind:group={form.send_weekly_report}
                  value={false}
                />
                <span>No</span>
              </label>
            </div>
          </div>
          <div class="col-start-2 col-span-3">
            <p class="text-gray-500 italic text-sm mt-2">
              Weekly progress reminder email and weekly activity page report.
            </p>
          </div>
        </div>
      </div>

      <div class="mt-3">
        <div
          class="grid grid-cols-4 gap-x-4 gap-y-2 items-start pt-5 justify-center"
        >
          <div class="col-span-2 md:col-span-1 flex items-center justify-end">
            <label
              for="username"
              class="block text-sm font-medium text-gray-700 text-right"
            >
              Weekly Team Meeting Day
            </label>
          </div>
          <div class="col-span-2 md:col-span-1">
            <div class="max-w-xs flex rounded-md shadow-sm items-center">
              <select
                name="weekly_meeting_day"
                class="mt-0"
                bind:value={form.weekly_meeting_day}
              >
                {#each WEEK_DAYS as wd, idx}
                  <option value={idx + 1}>{wd}</option>
                {/each}
              </select>
            </div>
          </div>
          <div class="col-start-2 col-span-3">
            <p class="text-gray-500 italic text-sm mt-2">
              This configures your Activity page and determines when to send the
              weekly report email.
            </p>
          </div>
        </div>
      </div>

      <div class="col-span-6 py-4 text-center mt-8">
        <button
          class="btn-rounded success btn-big"
          disabled={saving}
          on:click={() => saveEmailSettings()}
        >
          {#if saving}
            Saving..
          {:else}
            Save Settings
          {/if}
        </button>
      </div>
    {/if}
  </div>
</div>
